import { render, staticRenderFns } from "./layer-group-dialog-layer-item.vue?vue&type=template&id=2830c0a6&scoped=true&"
import script from "./layer-group-dialog-layer-item.vue?vue&type=script&lang=js&"
export * from "./layer-group-dialog-layer-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2830c0a6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
